// extracted by mini-css-extract-plugin
export default {"fullWidth":"cp-z","image":"dp-z","lazyLoadPicture":"ep-z","lazyLoadSpinner":"fp-z","lazyLoadSpin":"gp-z","lazyLoadImage":"hp-z","hasStyledAspectRatio":"ip-z"};